import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, getToken } from "@/api";
import { LiveWatch } from "@/components/LiveWatch";
import { Radio } from "lucide-react";

export default function PopoutLive() {
  const { id } = useParams();
  const [token, setToken] = useState(null);

  useEffect(() => {
    document.title = "Live beeld — DispatchMe";
    let stop = false;
    let iv = null;
    const load = () => api.get(`/incidents/${id}/live-active`).then(({ data }) => {
      if (stop) return;
      setToken(data.token);
      if (data.token && iv) { clearInterval(iv); iv = null; }
    }).catch(() => {});
    load();
    iv = setInterval(load, 5000);
    return () => { stop = true; if (iv) clearInterval(iv); };
  }, [id]);

  return (
    <div className="flex h-screen flex-col bg-black" data-testid="popout-live">
      <div className="flex items-center gap-2 px-4 py-2 text-sm font-semibold text-white">
        <Radio className="h-4 w-4 text-red-500" /> Live beeld van incident
      </div>
      <div className="flex flex-1 items-center justify-center p-3">
        {token ? (
          <div className="w-full max-w-5xl"><LiveWatch token={token} authToken={getToken()} /></div>
        ) : (
          <div className="text-sm text-slate-400">Geen actieve live-sessie. Wachten…</div>
        )}
      </div>
    </div>
  );
}
